import { Form, Formik } from "formik";
import React from "react";
import GovGrButton from "../../../../components/GovGrButton";
import { WARNING } from "../../../../components/GovGrButton/buttonConstants";
import GovGrTextField from "../../../../components/GovGrTextField";
import useLocale from "../../../../hooks/useLocale";
import * as Yup from "yup";
import { FIELD_IS_REQUIRED } from "../../../../constants";
import { useMutation } from "react-query";
import { getParavoloStatus } from "../../../../services/eParavolo";
import { useRef } from "react";
import CustomAlert from "../../../components/CustomAlert";
import { useState } from "react";
import {
  eParavoloStatusPayment,
  errorMessageParse,
} from "../../../../utils/errorMessage";
import { useContext } from "react";
import { EParavoloContext } from "../../../../context/eParavoloContext";

const SubmitDialog = ({
  close,
  submitData,
  paravolo,
  refetchUserApplicationData,
}) => {
  const { t } = useLocale();
  const [error, setError] = useState("");
  const formikRef = useRef();
  const { setParavoloStatus } = useContext(EParavoloContext);
  const initialValues = {
    paravoloPaymentCode: paravolo.paravoloCode || "",
    paravoloRfCode: paravolo.rfCode || "",
  };
  const validationSchema = Yup.object().shape({
    paravoloPaymentCode: Yup.string().required(t(FIELD_IS_REQUIRED)),
  });

  const { mutate } = useMutation(getParavoloStatus, {
    onSuccess: (data) => {
      setError(eParavoloStatusPayment(data.data));
      formikRef.current.setSubmitting(false);
      if (!error) {
        formikRef.current.resetForm();
        refetchUserApplicationData();
        close();
        setError("");
        setParavoloStatus({ paravolo_status_id: data.data });
      }
    },
    onError: (error) => {
      setError(errorMessageParse(error.response.status));
    },
  });

  const handleClose = () => {
    formikRef.current.resetForm();
    close();
    setError("");
  };
  return (
    <div className="flex flex-col">
      <CustomAlert
        open={!!error}
        close={() => {
          // refetch();
          setError("");
        }}
        message={t(`${error}`)}
      />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        innerRef={formikRef}
        onSubmit={(values, { setSubmitting }) => {
          mutate({
            ...submitData,
            ...values,
          });
          setSubmitting(false);
        }}
      >
        {({ handleSubmit, errors }) => {
          return (
            <Form>
              <GovGrTextField
                name="paravoloPaymentCode"
                label={t("Paravolo Code")}
                hint={t(
                  "Please type your 20 digit Paravolo Code (NOT RF CODE)"
                )}
              />
              <GovGrTextField
                name="paravoloRfCode"
                label={t("Paravolo RF Code")}
              />
              <div className="flex justify-end gap-2">
                <GovGrButton
                  onClick={handleSubmit}
                  type="submit"
                  buttonText={t("Submit")}
                />
                <GovGrButton
                  onClick={handleClose}
                  buttonText={t("Close")}
                  type="reset"
                  variant={WARNING}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default SubmitDialog;
